export { getTexts };
var texts = {
  mfaDialog: {
    backButtonLabel: 'Go Back'
  },
  factorSelector: {
    title: "Before signing in, let's make sure it's you",
    subTitle: 'Verifying with the app is easiest! We’ll guide you through a quick set-up, then it’s just one step to verify from here on out.',
    byAppLabel: 'Verify with app',
    byEmailLabel: 'Email code'
  },
  errorMessages: {
    generalError: {
      title: 'Sorry, let’s try that again',
      footer: 'We’re having some technical trouble on our end. ',
      footerLink: 'Try verifying again'
    },
    osPushDeclined: {
      title: 'Let’s get you verified a different way',
      body: 'If you want to switch to easy, 1-step verification with the app, head to your phone settings then <b>Chegg app</b>, then <b>notifications</b>, and tap ‘<b>allow</b>’.',
      footerLinkNavigation: 'Verify a different way'
    },
    appPushDeclined: {
      title: 'Sorry, we couldn’t verify your info',
      footerTextPart_1: 'No worries! You can ',
      footerRetryLink: 'try again',
      footerTextPart_2: ' or ',
      footerLinkNavigation: 'verify a different way'
    },
    sessionBlocked: {
      bannerTitle: 'You have reached your re-send limit',
      bannerMessage: 'Please try again in 5 minutes'
    },
    qrSessionExpired: {
      qrSessionExpiredTitle: 'This QR code expired',
      qrSessionExpiredMessage: 'Get a new code',
      qrSessionExpiredLink: 'here'
    },
    sentSessionExpired: {
      sessionExpiredTitle: 'Your session has expired',
      sessionExpiredMessage: 'Start a new session by clicking',
      sessionExpiredLink: 'here.'
    }
  },
  informationMessages: {
    signIn: {
      title: 'Just a minute as we sign you in...'
    },
    notificationSent: {
      title: 'Ok, we sent a notification to your phone',
      footerTextPart_1: 'Give it a tap or open the app to continue. No notification? ',
      footerRetryLink: 'Resend',
      footerTextPart_2: ' or ',
      footerLinkNavigation: 'verify a different way.'
    }
  },
  qr: {
    header: 'Download the app to get started',
    scan_qr: 'Get expert help anywhere, anytime.'
  }
};
function getTexts() {
  return texts;
}